export default __webpack_public_path__ + "static/media/ce-post2.dbabd7f4.png";